export enum ColorSchemeEnum {
  LIGHT = 'light',
  DARK = 'dark',
}

